module.exports = __webpack_public_path__ + "static/our-home-5f9b6bc31a2d0fdda146da8faef6c45a.jpg";